<template>
  <div class="prodct">
    <span v-if="data.category">
      <div :id="item.type" @mouseover="lindex=index" class="pdleval" v-for="item,index in data.category" :key="index">
        <label>{{item.label}}</label>
        <label>{{item.desc}}</label>
        <div @click="itemClick(item1.type,item.type)" @mouseover="lindex1=index1" @mouseleave="lindex1=-1" v-for="item1,index1 in data.data[item.type]" :key="index1">
          <img :src="item1.pic" />
          <p :class="lindex==index&&lindex1==index1?'hvp':''">{{item1.label}}</p>
        </div>
      </div>
    </span>
    <div id="hope" v-else>{{$t('lang.comesoon')}}...</div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    data: Object
  },
  watch: {
    data (n) {
      var index = 0
      if (n.type) {
        var i = 0
        this.data.category.forEach(item => {
          if (item.type==n.type) index=i
          i+=1
        });
      }
      this.menuSelect(index)
      n.type = ''
    }
  },
  data () {
    return {
      mnindex: 0,
      lindex: -1,
      lindex1: -1
    }
  },
  methods: {
    itemClick (type,ftype) {
      if (ftype=='property'||ftype=='s2830'||ftype=='lobby') {
        this.$message('Coming soon...')
        return
      }
      if (this.data.callback) this.data.callback(type)
    },
    setMenuClass (index) {
      return this.mnindex==index?'mnnlb mnslb':'mnnlb'
    },
    menuSelect (index) {
      this.mnindex = index
      // var items = this.data.data[this.data.category[index].type]
      // this.ctdatas = items?items:[]
    }
  },
  mounted () {
    // var _this = this
    // setTimeout(() => {
    //   _this.menuSelect(0)
    // }, 200);
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.prodct {
  background: #F7F8F8;
  min-height: 2.54rem;
  overflow: hidden;
  padding-top: .74rem;
  text-align: center;
}
.pdleval {
  width: 12.63rem;
  margin: 0 auto;
  text-align: left;
  margin-bottom: .58rem;
  cursor: pointer;
}
.pdleval label {
  display: block;
}
.pdleval label:nth-child(1) {
  font-size: .28rem;
  font-weight: 500;
  color: #303030;
  margin-bottom: .12rem;
}
.pdleval label:nth-child(2) {
  font-size: .20rem;
  font-weight: 400;
  color: #747474;
  width: 6rem;
  margin-bottom: .32rem;
  line-height: .28rem;
}
.pdleval div {
  width: 2.93rem;
  height: 3.88rem;
  display: inline-block;
  margin-right: .2rem;
  margin-bottom: .2rem;
  overflow: hidden;
}
.pdleval img {
  width: 2.93rem;
  height: 3.34rem;
  margin: 0;
  display: block;
}
.pdleval p {
  height: .54rem;
  margin: 0;
  text-align: center;
  line-height: .54rem;
  font-size: .2rem;
  font-weight: 400;
  color: #434343;
  background: #EDEDED;
}
.hvp {
  color: white !important;
  background: #EF8200 !important;
}
/* #menu {
  margin-top: .43rem;
  padding-bottom: .55rem;
  text-align: center;
} */
.mnnlb {
  display: inline-block;
  background: #EDEDED;
  padding: 0 .24rem 0 .24rem;
  height: .37rem;
  margin: 0 .08rem 0 .08rem;
  line-height: .37rem;
  font-size: .18rem;
  color: #747474;
  border-radius: .2rem;
}
.mnslb {
  background: white !important;
  color: #303030 !important;
}
#pdct {
  overflow: scroll;
  padding: 0 3.43rem 0 3.54rem;
}
#pdct div {
  display: inline-block;
  width: 2.86rem;
  height: 3.4rem;
  margin: 0 0 .3rem .3rem;
  text-align: center;
  overflow: hidden;
  cursor: pointer;
}
#pdct div:hover label {
  color: white;
  background: #EF8200;
}
#pdct img {
  width: 2.86rem;
  height: 2.86rem;
  display: block;
}
#pdct label {
  display: block;
  height: .54rem;
  line-height: .54rem;
  background: #EDEDED;
  font-size: .2rem;
  font-weight: 400;
  color: #434343;
}

#hope {
  text-align: center;
  margin-top: .6rem;
  font-size: .24rem;
  color: gray;
}
</style>
